<template>
    <div v-show="on" class="igc-ball">
        <div class="ig--close"
            @click="ballclose">
            <sui-icon class="ig--icon" name="close" fill="#fff"></sui-icon>
        </div>
        <div class="ig--image"
            :style="{ 'background-image': 'url(' + ball.img + ')'}"
            @click="to(ball.url)"></div>
    </div>
</template>

<script>
import mCore from '../../scripts/mixins/core'

export default {
    name: 'igc-ball',

    mixins: [mCore],

    data () {
        return {
            on: true
        }
    },

    props: {
        ball: {
            type: Object
        }
    },

    methods: {
        to(url) {
            if (sessionStorage.tokenParams) {
                url = url.includes('?') ? url + sessionStorage.tokenParams.replace('?', '&') : url + sessionStorage.tokenParams
            }
            location.assign(url)
        },
        ballclose() {
            this.on = false
            sessionStorage.ballStatus = this.on
        }
    }
}
</script>

<style lang="postcss">
.igc-ball {
    position: fixed;
    right: 7%;
    bottom: 12%;
    z-index: 1;
    .ig--close {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: -20px;
        top: -20px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.7);
        .ig--icon{
            width: 24px;
            height: 24px;
        }
    }
    .ig--image {
        width: 120px;
        height: 120px;
        background: no-repeat center / contain;
    }
}
</style>
